import type { BusinessTypePanel, CalculationRequestParams, CalculationResponse, ContainerRangePanel, ConversionPanel, FrequencyRangePanel, OverviewPanel, ProductSelectionPanel, ServiceTypeSelectionPanel, StoryPanel, SustainabilityCalculatorPanelTypes, SustainabilityCalculatorService } from "../../../typings/SustainabilityCalculator";
import { request } from "../../api/ApiHelpers";
import { CalculatorTypeKeyEnums } from "../../models/KeysEnum";

export async function fetchSustainabilityCalculatorPanels(apiPath: string): Promise<SustainabilityCalculatorPanelTypes[]> {
    return await request<SustainabilityCalculatorPanelTypes[]>({ url: apiPath }).then((data) => {
        return data;
    });
}

export async function fetchSustainabilityCalculatorConstants(apiPath: string): Promise<SustainabilityCalculatorService[]> {
    return await request<SustainabilityCalculatorService[]>({ url: apiPath }).then((data) => {
        return data;
    });
}

export async function fetchCalculation(apiPath: string, paramsObj: CalculationRequestParams): Promise<CalculationResponse> {
    return await request<CalculationResponse>({ url: apiPath, params: paramsObj }).then((data) => {
        return data;
    });
}

// panel type-guards that determine which panel is being rendered
export function isOverview(item: SustainabilityCalculatorPanelTypes): item is OverviewPanel {
    return (item as OverviewPanel).TypeKey === CalculatorTypeKeyEnums.OverviewType;
}
export function isServiceTypeSelection(item: SustainabilityCalculatorPanelTypes): item is ServiceTypeSelectionPanel {
    return (item as ServiceTypeSelectionPanel).TypeKey === CalculatorTypeKeyEnums.ServiceTypeSelectionType;
}
export function isProductSelection(item: SustainabilityCalculatorPanelTypes): item is ProductSelectionPanel {
    return (item as ProductSelectionPanel).TypeKey === CalculatorTypeKeyEnums.ProductSelectionType;
}
export function isContainerRange(item: SustainabilityCalculatorPanelTypes): item is ContainerRangePanel {
    return (item as ContainerRangePanel).TypeKey === CalculatorTypeKeyEnums.ContainerRangeType;
}
export function isFrequencyRange(item: SustainabilityCalculatorPanelTypes): item is FrequencyRangePanel {
    return (item as FrequencyRangePanel).TypeKey === CalculatorTypeKeyEnums.FrequencyRangeType;
}
export function isBusinessType(item: SustainabilityCalculatorPanelTypes): item is BusinessTypePanel {
    return (item as BusinessTypePanel).TypeKey === CalculatorTypeKeyEnums.BusinessType;
}
export function isConversion(item: SustainabilityCalculatorPanelTypes): item is ConversionPanel {
    return (item as ConversionPanel).TypeKey === CalculatorTypeKeyEnums.ConversionType;
}
export function isStory(item: SustainabilityCalculatorPanelTypes): item is StoryPanel {
    return (item as StoryPanel).TypeKey === CalculatorTypeKeyEnums.StoryType;
}